import { connect } from 'react-redux'
import GameAutoMessages from '../components/game-auto-messages'

const mapStateToProps = state => ({
  ...state.gameAutoMessages
})

const mapDispatchToProps = dispatch => ({
  onCreate: payload => dispatch({type: 'GAME_AUTO_MESSAGES.CREATE', payload}),
  onDelete: payload => dispatch({type: 'GAME_AUTO_MESSAGES.DELETE', payload}),
  onUpdate: payload => dispatch({type: 'GAME_AUTO_MESSAGES.UPDATED', payload}),
  onPageChange: payload => dispatch({type: 'GAME_AUTO_MESSAGES.PAGE_CHANGE', payload}),
  loadLocations: payload => dispatch({type: 'GAME_AUTO_MESSAGES.LOAD_LOCATIONS', payload}),
  onSearch: payload => dispatch({type: 'GAME_AUTO_MESSAGES.SEARCH', payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(GameAutoMessages)
